import {
  ADMIN_SERVLET_URL,
  GET_FULL_VENDOR_LIST_URL,
  GET_SERVICE_VENDOR_URL,
  LIST_VENDOR_DOMAIN_URL,
  VENDOR_10DLC_AVAILABLE_URL,
  VENDOR_TFN_AVAILABLE_URL,
  VENDOR_UNREGISTERED_URL,
} from 'consts/api';
import services from './index';
import QueryString from 'query-string';

class CommonServices {
  getUserVendor() {
    return services.get(GET_SERVICE_VENDOR_URL);
  }

  getDomainVendor() {
    return services.get(LIST_VENDOR_DOMAIN_URL);
  }

  getVendorAvailableFor10DLC() {
    return services.get(VENDOR_10DLC_AVAILABLE_URL);
  }

  getVendorAvailableForTFN() {
    return services.get(VENDOR_TFN_AVAILABLE_URL);
  }

  getVendorAvailableForUnregistered() {
    return services.get(VENDOR_UNREGISTERED_URL);
  }

  getAllConfig() {
    return services.post(`${ADMIN_SERVLET_URL}?action=getAllConfig`);
  }

  updateAllConfig(body) {
    return services.post(
      ADMIN_SERVLET_URL,
      QueryString.stringify({
        action: 'updateAllConfig',
        ...body,
      })
    );
  }

  updateConfig(body) {
    return services.post(
      ADMIN_SERVLET_URL,
      QueryString.stringify({
        action: 'updateConfig',
        ...body,
      })
    );
  }

  getAllVendorList() {
    return services.get(GET_FULL_VENDOR_LIST_URL);
  }

  deleteRedisCache() {
    return services.delete(`/api/v1/config/flushall`);
  }
}

export default new CommonServices();
